<template>
  <c-view v-min-height>
    <c-page>
      <c-content>
        <div class="alpha-register">
          <div class="header bg-img">
            <div class="header-desc">
              <img class="alpha-logo" src="../../assets/images/logo/logo.png" alt="">
              <div class="text-desc">欢迎注册生意专家</div>
            </div>
          </div>
          <div class="content">
            <div class="register-form">
              <form action="">
                <div class="s-form-group">
                  <i class="s-icon s-icon-store prepend-icon"></i>
                  <input type="text" class="prepend-icon" @input="validName=false" @blur="validateName()" placeholder="店铺名称（8个字以内）" v-model="formItem.storeName">
                  <i class="s-icon s-icon-check-circle-italic" v-show="validName"></i>
                </div>
                <div class="s-form-group">
                  <i class="s-icon s-icon-telephone prepend-icon"></i>
                  <input type="phone" class="prepend-icon" @input="validPhone=false" placeholder="请输入手机号码" @blur="validatePhone()" v-model="formItem.telephoneNum">
                  <i class="s-icon s-icon-check-circle-italic" v-show="validPhone"></i>
                </div>
                <div class="s-form-group">
                  <i class="s-icon s-icon-password prepend-icon"></i>
                  <input type="password" class="prepend-icon" @input="validPass=false" placeholder="请输入密码" @blur="validatePass()" v-model="formItem.passwordNum">
                  <i class="s-icon s-icon-check-circle-italic" v-show="validPass"></i>
                </div>
              </form>
            </div>
            <div class="s-btn s-btn--orange" @click="nextStep()">下一步</div>
            <p class="mt-20 text-center text-color gray">点击下一步，即同意 <a @click="goUserTerm()" class="text-color orange">《生意专家用户协议》</a>
            </p>
          </div>
          <div class="footer-container">
            <info-footer></info-footer>
          </div>
        </div>
      </c-content>
    </c-page>
    <router-view></router-view>
  </c-view>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  import SignUpModel from '../../model/alpha-sign-up/form'
  import InfoFooter from '../info-footer'

  export default {
    data () {
      const formModel = new SignUpModel()
      return {
        formModel,
        formItem: formModel.formItem,
        validName: false,
        validPhone: false,
        validPass: false
      }
    },
    components: {InfoFooter},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      testPhone (value) {
        return /^1\d{10}$/.test(value)
      },
      testName (value) {
        return value && value.length < 9
      },
      testNull (value) {
        return value && value.length !== 0
      },
      validatePhone () {
        // 执行验证手机号码是否注册
        return new Promise(resolve => {
          if (!this.testNull(this.formItem.telephoneNum)) {
            this.$wejs.alert('手机号不能为空')
            this.validPhone = false
            return resolve(false)
          }
          if (!this.testPhone(this.formItem.telephoneNum)) {
            this.$wejs.alert('请输入正确的手机号码')
            this.validPhone = false
            return resolve(false)
          }
          this.formModel.haveSignup().then(res => {
            let data = res
            if (data && data.length > 0) {
              this.validPhone = false
              this.$wejs.alert('此号码已注册')
              resolve(false)
            } else {
              this.validPhone = true
              resolve(true)
            }
          })
        })
      },
      validateName () {
        if (!this.testName(this.formItem.storeName)) {
          this.$wejs.alert('店铺名称长度不超8位')
          this.validName = false
          return
        }
        if (!this.testNull(String.trim(this.formItem.storeName))) {
          this.$wejs.alert('店铺名不能为空')
          this.validName = false
          return
        }
        this.validName = true
        return true
      },
      validatePass () {
        if (!this.formItem.passwordNum) {
          this.$wejs.alert('请输入密码')
          this.validPass = false
          return
        }
        if (this.formItem.passwordNum.length < 6) {
          this.$wejs.alert('密码不能少于六位')
          this.validPass = false
          return
        }
        this.validPass = true
        return true
      },
      haveSignupFunc () {
        this.formModel.haveSignup().then(res => {
          let data = res
          if (data && data.length > 0) {
            this.$wejs.alert('此号码已注册')
            this.validPhone = false
          } else {
            console.log('获取验证码')
            this.getVerifyCodeFunc()
          }
        })
      },
      getVerifyCodeFunc () {
        this.formModel.getVerifyCode().then((v) => {
          if (v === 0) {
            this.$wejs.toast('验证码已发送')
            this.formItem.codeWorking = true
            this.$router.push({path: '/sign-up/verify', query: this.formItem})
          }
        }).catch((e) => {
          this.$wejs.alert('抱歉发送出错', () => {
            this.$router.push({path: '/sign-up'})
          })
        })
      },
      async nextStep () {
        if (!this.validateName() || !this.validatePass() || !await this.validatePhone()) return
        this.haveSignupFunc()
      },
      goUserTerm () {
        this.$router.push({path: '/sign-up/user-term'})
      }
    },
    computed: {},
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?3f1bb232